const ADMINISTRATOR = 'administrator';
const TEACHER = 'teacher';
const ACADEMIC = 'academic';
const STUDENT = 'student';
const REPRESENTATIVE = 'representative';
const SECRETARY = 'secretary';
const SUSTAINER = 'sustainer';
const USER = 'user';

export {
  ADMINISTRATOR,
  TEACHER,
  ACADEMIC,
  STUDENT,
  REPRESENTATIVE,
  SECRETARY,
  SUSTAINER,
  USER,
};
